import { Spinner } from '@/components/ui/Spinner';
import { useT } from '@/lib/i18n';

/** Shown by the router while the very first (lazy) route module is being fetched. */
export function HydrateFallback() {
  const t = useT();
  return (
    <div className="grid min-h-dvh place-items-center" role="status" aria-live="polite">
      <div className="flex items-center gap-3 text-fg-muted">
        <Spinner size={24} />
        <span className="t-small">{t('common.loading')}</span>
      </div>
    </div>
  );
}
